(() => {
  'use strict';
  const dialog = document.getElementById('ebd-pair-dialog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  let opener;
  const busy = () => dialog.querySelector('[data-vp-form]')?.getAttribute('aria-busy') === 'true';
  dialog.querySelector('[data-pair-close]').addEventListener('click',() => { if (!busy()) dialog.close(); });
  dialog.addEventListener('cancel',event => { if (busy()) event.preventDefault(); });
  dialog.addEventListener('close',() => { document.body.classList.remove('ebd-pair-open'); if (opener?.isConnected) opener.focus({preventScroll:true}); });
  document.addEventListener('click',event => {
    const trigger = event.target.closest('[data-ebd-pair-open]');
    if (!trigger) return;
    event.preventDefault(); opener = trigger;
    dialog.showModal(); document.body.classList.add('ebd-pair-open');
    const section = dialog.querySelector('[data-visual-pair]');
    if (section) {
      section.dataset.source = trigger.dataset.pairSource || 'collection';
      section.dispatchEvent(new CustomEvent('ebd:bundle-select',{detail:{first:trigger.dataset.pairProduct,second:trigger.dataset.pairSecond}}));
    }
  });
})();
